<h2 mat-dialog-title>Chart Still Active</h2>

<mat-dialog-content>
  <div *ngIf="!isDeactivating && !deactivationSuccess" class="warning-content">
    <mat-icon class="warning-icon">warning</mat-icon>
    <p class="warning-message">
      The chart <strong>{{ data.description }}</strong> for <strong>{{ data.residentName }}</strong>
      is still active and will continue generating new worklog activities.
    </p>
    <p class="info-message">
      You need to deactivate the chart before deleting the pre-generated activity instances.
    </p>
  </div>

  <div *ngIf="isDeactivating" class="deactivating-content">
    <mat-spinner diameter="48"></mat-spinner>
    <p class="deactivating-text">Deactivating chart...</p>
  </div>

  <div *ngIf="deactivationSuccess" class="success-content">
    <mat-icon class="success-icon">check_circle</mat-icon>
    <p class="success-text">Chart deactivated successfully!</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="!isDeactivating && !deactivationSuccess">
  <button mat-button (click)="onCancel()" [disabled]="isDeactivating">
    Cancel
  </button>
  <button mat-button color="primary" (click)="onDeactivateInEcase()" [disabled]="isDeactivating">
    I'll deactivate in eCase
  </button>
  <button mat-raised-button color="accent" (click)="onDeactivateForMe()" [disabled]="isDeactivating">
    Deactivate for me
  </button>
</mat-dialog-actions>
